import React from 'react';
import { WizardItem } from '../Interfaces/Wizard.interface';
import { WizardItemType } from '../Enums/WizardItemType.enum';
import WizardText from './v2/WizardText/WizardText';
import WizardTextField from './v2/WizardTextField/WizardTextField';
import WizardSubmitButton from './v2/WizardSubmitButton/WizardSubmitButton';
import WizardCheckbox from './v2/WizardCheckbox/WizardCheckbox';
import WizardImage from './v2/WizardImage/WizardImage';
import WizardButton from './v2/WizardButton/WizardButton';
import WizardVStack from './v2/WizardVStack/WizardVStack';
import WizardHStack from './v2/WizardHStack/WizardHStack';
import WizardContainer from './v2/WizardContainer/WizardContainer';
import WizardSpacer from './v2/WizardSpacer/WizardSpacer';
import WizardFamilyMemberCard from './v2/WizardFamilyMemberCard/WizardFamilyMemberCard';
import WizardSelect from './v2/WizardSelect/WizardSelect';
import WizardCondition from './v2/WizardCondition/WizardCondition';
import WizardCodeInput from './v2/WizardCodeInput/WizardCodeInput';
import WizardCollapse from './v2/WizardCollapse/WizardCollapse';
import WizardRadioList from './v2/WizardRadioList/WizardRadioList';
import WizardDate from './v2/WizardDate/WizardDate';
import WizardTextArea from './v2/WizardTextArea/WizardTextArea';
import WizardMultiplier from './v2/WizardMultiplier/WizardMultiplier';
import WizardUserRelations from './v2/WizardUserRelations/WizardUserRelations';
import WizardUpload from './v2/WizardUpload/WizardUpload';
import MultiFileWizardUpload from './v2/WizardMultiFileUpload/WizardMultiFileUpload';
import WizardImageCard from './v2/WizardImageCard/WizardImageCard';
import WizardAgreementList from './v2/WizardAgreementList/WizardAgreementList';

interface Props {
	item: WizardItem;
	onSubmit: (values: object) => void;
}

const WizardChildren: React.FC<Props> = ({ item, onSubmit }) => {
	switch (item.type) {
		case WizardItemType.TEXT:
			return <WizardText item={item} />;
		case WizardItemType.TEXT_FIELD:
		case WizardItemType.TEXT_FIELD_2:
			return <WizardTextField item={item} />;
		case WizardItemType.SUBMIT_BUTTON:
			return <WizardSubmitButton item={item} onSubmit={onSubmit} />;
		case WizardItemType.CHECKBOX:
			return <WizardCheckbox item={item} />;
		case WizardItemType.IMAGE:
			return <WizardImage item={item} />;
		case WizardItemType.BUTTON:
			return <WizardButton item={item} onSubmit={onSubmit} />;
		case WizardItemType.V_STACK:
			return <WizardVStack item={item} onSubmit={onSubmit} />;
		case WizardItemType.H_STACK:
			return <WizardHStack item={item} onSubmit={onSubmit} />;
		case WizardItemType.CONTAINER:
			return <WizardContainer item={item} onSubmit={onSubmit} />;
		case WizardItemType.SPACER:
			return <WizardSpacer item={item} />;
		case WizardItemType.FAMILY_MEMBER_CARD:
			return <WizardFamilyMemberCard item={item} />;
		case WizardItemType.SELECT:
			return <WizardSelect item={item} />;
		case WizardItemType.CONDITION:
			return <WizardCondition item={item} onSubmit={onSubmit} />;
		case WizardItemType.CODE_INPUT:
			return <WizardCodeInput item={item} />;
		case WizardItemType.COLLAPSE:
			return <WizardCollapse item={item} onSubmit={onSubmit} />;
		case WizardItemType.RADIO_LIST:
			return <WizardRadioList item={item} />;
		case WizardItemType.DATE:
		case WizardItemType.DATE_PICKER:
			return <WizardDate item={item} />;
		case WizardItemType.TEXT_AREA:
		case WizardItemType.TEXT_AREA_2:
			return <WizardTextArea item={item} />;
		case WizardItemType.MULTIPLIER:
			return <WizardMultiplier item={item} onSubmit={onSubmit} />;
		case WizardItemType.USER_RELATIONS:
			return <WizardUserRelations item={item} />;
		case WizardItemType.UPLOAD:
			return <WizardUpload item={item} />;
		case WizardItemType.MULTI_UPLOAD:
			return <MultiFileWizardUpload item={item} />;
		case WizardItemType.IMAGE_CARD:
			return <WizardImageCard item={item} />;
		case WizardItemType.AGREEMENT_LIST:
			return <WizardAgreementList item={item} />;
		default:
			return <>UNSUPORTED ITEM: {item.type}</>;
	}
};

export default WizardChildren;
